import * as React from "react";
import {
  createBrowserRouter
} from "react-router-dom";

/* =============== Import Pages ==================== */
import Layout from "../components/layout";

import Projects from '../pages/Projects';
import Dashboard from "../pages/Dashboard";
import Profile from "../pages/Profile";
import PageNotFound from "../pages/Error/PageNotFound";
import Login from "../pages/Authentication/Login";
import Register from "../pages/Authentication/Register";
import PrivateRoute from "../components/router/privateRoute";
import Logout from "../pages/Authentication/Logout";
import Users from "../pages/Users";
import UserNewEditPage from "../pages/Users/UserNewEditPage";
import Groups from "../pages/Groups";
import GroupNewEditPage from "../pages/Groups/GroupNewEditPage"
import Configurations from "../pages/Configurations";
import Catalog from "../pages/Catalog";
import ProductNewEditPage from "../pages/Catalog/ProductNewEditPage";
import ForgotPassword from "../pages/Authentication/ForgotPassword";
import ResetPassword from "../pages/Authentication/ResetPassword";
import AccountActivation from "../pages/Authentication/AccountActivation";
import ConfigurationNewEditPage from "../pages/Configurations/ConfigurationNewEditPage";
import ConfigurationEditPage from "../pages/Configurations/ConfiguratorEditPage";
import Sectors from "../pages/Sectors";
import Agencies from "../pages/Agencies";
import Departments from "../pages/Departments";
import SectorNewEditPage from "../pages/Sectors/SectorNewEditPage";
import AgencyNewEditPage from "../pages/Agencies/AgencyNewEditPage";
import DepartmentNewEditPage from "../pages/Departments/DepartmentNewEditPage";
/* ------------------------------------------------- */

export const routes = [
  {
    path: '/',
    key: 'login',
    element: <Login />
  },
  {
    path: '/login',
    key: 'login',
    element: <Login />
  },
  {
    path: '/register',
    key: 'register',
    element: <Register />
  },
  {
    path: '/logout',
    key: 'logout',
    element: <Logout />
  },
  {
    path: '/projects',
    key: 'projects',
    rightName: 'project',
    rights: ['r'],
    element: <PrivateRoute element={
      <Layout>
        <Projects />
      </Layout>
    } />
  },
  {
    path: '/dashboard',
    key: 'dashboard',
    rightName: 'dashboard',
    rights: ['r'],
    element: <PrivateRoute element={
      <Layout>
        <Dashboard />
      </Layout>
    } />
  },
  {
    path: '/profile',
    key: 'profile',
    element: <PrivateRoute element={
      <Layout>
        <Profile />
      </Layout>
    } />
  },
  //USERS
  {
    path: '/users',
    key: 'users',
    rightName: 'user',
    rights: ['r'],
    element: <PrivateRoute element={
      <Layout>
        <Users />
      </Layout>
    } />
  },
  {
    path: '/users/:id',
    key: 'users',
    rightName: 'user',
    rights: ['c','w'],
    element: <PrivateRoute element={
      <Layout>
        <UserNewEditPage />
      </Layout>
    } />
  },
  {
    path: '/groups',
    key: 'groups',
    rightName: 'group',
    rights: ['r'],
    element: <PrivateRoute element={
      <Layout>
        <Groups />
      </Layout>
    } />
  },
  {
    path: '/groups/:id',
    key: 'groups',
    rightName: 'group',
    rights: ['c','w'],
    element: <PrivateRoute element={
      <Layout>
        <GroupNewEditPage />
      </Layout>
    } />
  },
  {
    path: '/sectors',
    key: 'sectors',
    rightName: 'sector',
    rights: ['c','w'],
    element: <PrivateRoute element={
      <Layout>
        <Sectors />
      </Layout>
    } />
  },
  {
    path: '/sectors/:id',
    key: 'sectors',
    rightName: 'sector',
    rights: ['c','w'],
    element: <PrivateRoute element={
      <Layout>
        <SectorNewEditPage />
      </Layout>
    } />
  },
  {
    path: '/agencies',
    key: 'agencies',
    rightName: 'agency',
    rights: ['c','w'],
    element: <PrivateRoute element={
      <Layout>
        <Agencies />
        </Layout>
    } />
  },
  {
    path: '/agencies/:id',
    key: 'agencies',
    rightName: 'agency',
    rights: ['c','w'],
    element: <PrivateRoute element={
      <Layout>
        <AgencyNewEditPage />
      </Layout>
    } />
  },
  {
    path: '/departments',
    key: 'departments',
    rightName: 'department',
    rights: ['c','w'],
    element: <PrivateRoute element={
      <Layout>
        <Departments />
        </Layout>
    } />
  },
  {
    path: '/departments/:id',
    key: 'departments',
    rightName: 'department',
    rights: ['c','w'],
    element: <PrivateRoute element={
      <Layout>
        <DepartmentNewEditPage />
      </Layout>
    } />
  },
  {
    path: '/configurations',
    key: 'configurations',
    rightName: 'configuration',
    rights: ['r'],
    element: <PrivateRoute element={
      <Layout>
        <Configurations />
      </Layout>
    } />
  },
  {
    path: '/configurations/:id',
    key: 'configurations',
    rightName: 'configuration',
    rights: ['c','w'],
    element: <PrivateRoute element={
      <Layout>
        <ConfigurationNewEditPage />
      </Layout>
    } />
  },
  {
    path: '/configurations/configurator/:id',
    key: 'configurations',
    rightName: 'configuration',
    rights: ['c','w'],
    element: <PrivateRoute element={
      <Layout>
        <ConfigurationEditPage />
      </Layout>
    } />
  },
  {
    path: '/catalogs',
    key: 'catalogs',
    rightName: 'catalog',
    rights: ['r'],
    element: <PrivateRoute element={
      <Layout>
        <Catalog />
      </Layout>
    } />
  },
  /*{
    path: '/catalogs/:id',
    key: 'catalogs',
    rightName: 'catalog',
    rights: ['c','w'],
    element: <PrivateRoute element={
      <Layout>
        <ProductNewEditPage />
      </Layout>
    } />
  },*/
  {
    path: '/forgotPassword',
    key: 'forgotPassword',
    element: <ForgotPassword />
  },
  {
    path: '/resetPassword/:token',
    key: 'resetPassword',
    element: <ResetPassword />
  },
  {
    path: '/activateAccount/:token',
    key: 'activateAccount',
    element: <AccountActivation />
  },
  {
    path: '*',
    element: <PageNotFound />
  }
]


export const router = createBrowserRouter(routes);

export default router;
